var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"block":""},on:{"click":_vm.reset}},[_vm._v(" "+_vm._s(_vm.data.title)+" "),(_vm.data.icon)?_c('v-icon',{attrs:{"right":""}},[_vm._v(" "+_vm._s(_vm.data.icon)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }